
import { useState } from "react";
import { Button, Dropdown, ButtonGroup, Form, InputGroup } from "react-bootstrap";

const Filters = ({
  onGenreChange,
  onTrendingToggle,
  onReset,
  selectedGenre,
  isTrending,
  searchTerm,
  setSearchTerm
}) => {
  const genres = ["All", "Action", "Fantasy", "Mecha", "Romance", "Comedy"];

  return (
    <div className="mb-4">
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-3">
        <Dropdown as={ButtonGroup}>
          <Button variant="secondary">
            {selectedGenre ? selectedGenre : "Filter by Genre"}
          </Button>
          <Dropdown.Toggle split variant="secondary" id="dropdown-split-basic" />

          <Dropdown.Menu>
            {genres.map((genre) => (
              <Dropdown.Item
                key={genre}
                active={selectedGenre === genre}
                onClick={() => onGenreChange(genre === "All" ? null : genre)}
              >
                {genre}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>

        <Form.Check
          type="switch"
          id="trending-toggle"
          label="Trending Only"
          checked={isTrending}
          onChange={() => onTrendingToggle(!isTrending)}
        />

        <Button variant="outline-light" onClick={onReset}>
          Reset Filters
        </Button>
      </div>

      <InputGroup>
        <Form.Control
          type="text"
          placeholder="Search by title..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </InputGroup>
    </div>
  );
};

export default Filters;